import { useState } from 'react';
import { Card, Title, Text, Box, Link, Icon } from '@nimbus-ds/components';
import { PlusCircleIcon } from '@nimbus-ds/icons';
import { Responsive } from 'commons/components';
import { useModal } from 'commons/hooks';
import { useTranslationAccount } from 'domains/Account/hooks';
import {
  GeneralTax,
  ExceptionsResultDesktop,
  TaxExceptionsModal,
  ExceptionsResultMobile,
} from './components';

// TODO: get taxRate from API
const dataMock = [
  {
    id: '1',
    description: 'tax-gral',
    is_general: true,
    iva_rate: 21,
    products: [],
  },
  {
    id: '2',
    description: 'tax-product-1',
    is_general: false,
    iva_rate: 10,
    products: [
      {
        product_id: '113893390',
      },
      {
        product_id: '113893391',
      },
    ],
  },
];

export type ExceptionProductsType = {
  id: string;
  description: string;
  is_general: boolean;
  iva_rate: number;
  products: { product_id: string }[];
};

function TaxExceptionsCard() {
  const [checked, setChecked] = useState(true);
  const [isShowModal, openModal, closeModal] = useModal();
  const [data, setData] = useState(dataMock);
  const [editingItem, setEditingItem] = useState<ExceptionProductsType | null>(
    null,
  );
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions');
  const taxRateGeneral =
    dataMock.find((item) => item.is_general)?.iva_rate || 0;

  const onCheckChange = (checked: boolean) => {
    setChecked(checked);
  };

  const handleDelete = (id: string) => {
    setData((prevData) => prevData.filter((item) => item.id !== id));
  };

  const handleAddNew = () => {
    setEditingItem(null);
    openModal();
  };

  const handleCloseModal = () => {
    setEditingItem(null);
    closeModal();
  };

  const exceptionsData = data.filter((item) => !item.is_general);

  const handleEdit = (id: string) => {
    const itemToEdit = data.find((item) => item.id === id);
    if (itemToEdit) {
      setEditingItem(itemToEdit);
      openModal();
    }
  };

  return (
    <Card>
      <Card.Header>
        <Title as="h4">{t('title')}</Title>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="3">
          <GeneralTax
            checked={checked}
            taxRate={taxRateGeneral}
            onCheckChange={onCheckChange}
          />
          <Box display="flex" flexDirection="column" gap="2">
            <Text fontWeight="bold">{t('subtitle')}</Text>
            <Text>{t('description')}</Text>
          </Box>
          <Link
            appearance="primary"
            as="button"
            textDecoration="none"
            onClick={handleAddNew}
          >
            <Icon color="currentColor" source={<PlusCircleIcon />} />
            {t('addExceptions')}
          </Link>
          {exceptionsData.length > 0 && (
            <Responsive
              mobile={
                <ExceptionsResultMobile
                  data={exceptionsData}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              }
              desktop={
                <ExceptionsResultDesktop
                  data={exceptionsData}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              }
            />
          )}
          {isShowModal && (
            <TaxExceptionsModal
              onClose={handleCloseModal}
              isOpen={isShowModal}
              editingItem={editingItem}
            />
          )}
        </Box>
      </Card.Body>
    </Card>
  );
}

export default TaxExceptionsCard;
